import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/auth-context'
import { Table } from 'antd'
import { PerEmpty } from '../../../components/custom_components/Empty'
import { useDateTime } from '../../../shared/useDateTime'
import { ReviewerAndEmployee } from '../../../types'
import { DeleteReviewerModal } from './DeleteReviewerModal'
import { getReviewerTableColumns } from './reviewerTableColumns'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { tableActionButtons } from '../../../components/custom_components/TableActionButtons/tableActionButtons.uiprops'

interface Props {
  tableData: ReviewerAndEmployee[]
  buId: string
}

export const BuReviewerTable: FC<Props> = ({ tableData, buId }) => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [relationToDelete, setRelationToDelete] = useState<ReviewerAndEmployee | null>(null)

  const { formatDateShort } = useDateTime(user)
  const { tableActionButtonsRowWidth } = tableActionButtons()

  const columns = [
    ...getReviewerTableColumns({
      t,
      user,
      formatDateShort,
    }),
    {
      key: 'reviewer-actions',
      title: t('companySettingsView.reviewerTab.table.actions.heading'),
      width: tableActionButtonsRowWidth(1),
      render: (tableData: ReviewerAndEmployee) => (
        <>
          {tableData.canDelete && (
            <PerButtonCircle
              variant="pastel"
              color="error"
              icon="delete_fill"
              tooltip={t('companySettingsView.reviewerTab.table.actions.deleteBtnTooltip')}
              onClick={() => setRelationToDelete(tableData)}
            />
          )}
        </>
      ),
    },
  ]

  const tData = tableData.map((employee) => ({ ...employee, key: employee.id }))

  return (
    <>
      <DeleteReviewerModal onClose={() => setRelationToDelete(null)} relationToDelete={relationToDelete} buId={buId} />
      <Table
        className="light small viewWithTabsAndInfoBox scroll-compensation"
        rowClassName={() => 'minHeight-row'}
        dataSource={tData}
        columns={columns}
        pagination={false}
        scroll={{ y: true }}
        locale={{
          emptyText: <PerEmpty icon="employeesNo_stroke" heading={t('companySettingsView.reviewerTab.table.empty.buHeading')} />,
        }}
      />
    </>
  )
}
